<template>
  <transition name="modal">
    <div
      v-if="isVisible"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      @click.self="closeModal"
    >
      <div class="relative bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <button
          @click="closeModal"
          class="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div class="text-center">
  <label class="font-semibold">
    {{
      type === "notes"
        ? "Submitter Notes / Comments"
        : "Products Selected"
    }}
  </label>
  <slot>
    <!-- Dividir por saltos de línea y mapear cada parte en <p> o <br> -->
    <p class="text-gray-700 text-lg">
      <span v-for="(line, index) in text.split('\n')" :key="index">
        {{ line }}<br v-if="index !== text.split('\n').length - 1" />
      </span>
    </p>
  </slot>
</div>
      </div>
    </div>
  </transition>
</template>
  
  <script>
  import { ref, onMounted, onBeforeUnmount } from "vue";
  
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: "This is a modal content",
      },
      type: {
        type: String,
        default: "notes",
      } 
    },
    setup(props, { emit }) {
      const isVisible = ref(props.visible);
  
      function closeModal() {
        isVisible.value = false;
        emit("close");
      }
  
      function handleEscapeKey(event) {
        if (event.key === "Escape") {
          closeModal();
        }
      }
  
      
      onMounted(() => {
        window.addEventListener("keydown", handleEscapeKey);
      });
  
      onBeforeUnmount(() => {
        window.removeEventListener("keydown", handleEscapeKey);
      });
  
      return {
        isVisible,
        closeModal,
      };
    },
    watch: {
      visible(newVal) {
        this.isVisible = newVal;
      },
    },
  };
  </script>
  
  <style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>
  